import { cva } from '@/styled-system/css';

export const duoColorIconRecipe = cva({
  base: {
    'alignItems': 'center',
    'blockSize': 'DuoColorIcon.Root.size',
    'borderRadius': 'DuoColorIcon.Root.borderRadius',
    'display': 'flex',
    'flex': '0 0 auto',
    'inlineSize': 'DuoColorIcon.Root.size',
    'justifyContent': 'center',
    '& [data-c11n-component="Icon"]': {
      blockSize: 'DuoColorIcon.Icon.size',
      inlineSize: 'DuoColorIcon.Icon.size',
    },
  },
  compoundVariants: [
    // trust variants
    {
      tone: 'trust',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.trust.default.bg',
        color: 'DuoColorIcon.trust.default.icon',
      },
    },
    {
      tone: 'trust',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.trust.onHero.bg',
        color: 'DuoColorIcon.trust.onHero.icon',
      },
    },
    {
      tone: 'trust',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.trust.onImpact.bg',
        color: 'DuoColorIcon.trust.onImpact.icon',
      },
    },

    // insight variants
    {
      tone: 'insight',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.insight.default.bg',
        color: 'DuoColorIcon.insight.default.icon',
      },
    },
    {
      tone: 'insight',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.insight.onHero.bg',
        color: 'DuoColorIcon.insight.onHero.icon',
      },
    },
    {
      tone: 'insight',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.insight.onImpact.bg',
        color: 'DuoColorIcon.insight.onImpact.icon',
      },
    },

    // inspire variants
    {
      tone: 'inspire',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.inspire.default.bg',
        color: 'DuoColorIcon.inspire.default.icon',
      },
    },
    {
      tone: 'inspire',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.inspire.onHero.bg',
        color: 'DuoColorIcon.inspire.onHero.icon',
      },
    },
    {
      tone: 'inspire',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.inspire.onImpact.bg',
        color: 'DuoColorIcon.inspire.onImpact.icon',
      },
    },

    // empower variants
    {
      tone: 'empower',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.empower.default.bg',
        color: 'DuoColorIcon.empower.default.icon',
      },
    },
    {
      tone: 'empower',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.empower.onHero.bg',
        color: 'DuoColorIcon.empower.onHero.icon',
      },
    },
    {
      tone: 'empower',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.empower.onImpact.bg',
        color: 'DuoColorIcon.empower.onImpact.icon',
      },
    },

    // info variants
    {
      tone: 'info',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.info.default.bg',
        color: 'DuoColorIcon.info.default.icon',
      },
    },
    {
      tone: 'info',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.info.onHero.bg',
        color: 'DuoColorIcon.info.onHero.icon',
      },
    },
    {
      tone: 'info',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.info.onImpact.bg',
        color: 'DuoColorIcon.info.onImpact.icon',
      },
    },

    // success variants
    {
      tone: 'success',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.success.default.bg',
        color: 'DuoColorIcon.success.default.icon',
      },
    },
    {
      tone: 'success',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.success.onHero.bg',
        color: 'DuoColorIcon.success.onHero.icon',
      },
    },
    {
      tone: 'success',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.success.onImpact.bg',
        color: 'DuoColorIcon.success.onImpact.icon',
      },
    },

    // critical variants
    {
      tone: 'critical',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.critical.default.bg',
        color: 'DuoColorIcon.critical.default.icon',
      },
    },
    {
      tone: 'critical',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.critical.onHero.bg',
        color: 'DuoColorIcon.critical.onHero.icon',
      },
    },
    {
      tone: 'critical',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.critical.onImpact.bg',
        color: 'DuoColorIcon.critical.onImpact.icon',
      },
    },

    // warning variants
    {
      tone: 'warning',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.warning.default.bg',
        color: 'DuoColorIcon.warning.default.icon',
      },
    },
    {
      tone: 'warning',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.warning.onHero.bg',
        color: 'DuoColorIcon.warning.onHero.icon',
      },
    },
    {
      tone: 'warning',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.warning.onImpact.bg',
        color: 'DuoColorIcon.warning.onImpact.icon',
      },
    },

    // notify variants
    {
      tone: 'notify',
      onBackground: 'default',
      css: {
        backgroundColor: 'DuoColorIcon.notify.default.bg',
        color: 'DuoColorIcon.notify.default.icon',
      },
    },
    {
      tone: 'notify',
      onBackground: 'hero',
      css: {
        backgroundColor: 'DuoColorIcon.notify.onHero.bg',
        color: 'DuoColorIcon.notify.onHero.icon',
      },
    },
    {
      tone: 'notify',
      onBackground: 'impact',
      css: {
        backgroundColor: 'DuoColorIcon.notify.onImpact.bg',
        color: 'DuoColorIcon.notify.onImpact.icon',
      },
    },
  ],
});
